import React from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleCheckStatus = () => {
    navigate('/check-status');
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Fallback gradient - behind everything */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-blue-900 to-purple-900"></div>
      
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(/bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Semi-transparent dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <img
          className="w-full h-full"
          src="/embassy.jpg"
           alt="Background"
        >
        </img>
        {/* Modal-like Box */}
        <div className="bg-white  shadow-2xl px-8 md:px-12 py-4 md:py-4 transform transition-all">
          {/* Header/Title */}
          
          <div className="text-center mb-8">
           
            <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
              Visa Application Portal
            </h1>
            <div className="w-24 h-1 bg-indigo-600 mx-auto rounded-full"></div>
          </div>

          {/* Bullet Points */}
          <div className="space-y-4 mb-10">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg
                  className="h-6 w-6 text-indigo-600 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <p className="ml-3 text-lg text-gray-700">
                Track your visa status easily
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg
                  className="h-6 w-6 text-indigo-600 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <p className="ml-3 text-lg text-gray-700">
                Get instant updates on your application
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg
                  className="h-6 w-6 text-indigo-600 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <p className="ml-3 text-lg text-gray-700">
                Download your approved visa document
              </p>
            </div>
          </div>

          {/* Button */}
          <div className="text-center">
            <button
              onClick={handleCheckStatus}
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-4 px-10 rounded-lg text-lg shadow-lg transform transition-all hover:scale-105 hover:shadow-xl w-full md:w-auto"
            >
              Check Visa Status
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
